(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initBlogCards(root) {
      if (!root || root.dataset.bcInit === 'true') return;
      root.dataset.bcInit = 'true';

      var input = root.querySelector('[data-bc-search]');
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-bc-card]'));
      var empty = root.querySelector('[data-bc-empty]');
      if (!input || !cards.length) return;

      input.addEventListener('input', function () {
        var query = input.value.trim().toLowerCase();
        var visible = 0;

        cards.forEach(function (card) {
          var text = card.getAttribute('data-search') || '';
          var match = !query || text.indexOf(query) !== -1;
          card.hidden = !match;
          if (match) visible++;
        });

        if (empty) empty.hidden = visible !== 0;
      });
    }

    function initAll() {
      document.querySelectorAll('[data-blog-cards]').forEach(initBlogCards);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var el = event.target && event.target.querySelector ? event.target.querySelector('[data-blog-cards]') : null;
      if (el) initBlogCards(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["build-a-box"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const GHOST_SIZE = 88;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

    const fill = (template, values) =>
      String(template || '').replace(/\{(\w+)\}/g, (match, key) =>
        values && values[key] !== undefined ? values[key] : match
      );

    const tf = (x, y, rotate, scale) =>
      'translate3d(' + (x - GHOST_SIZE / 2) + 'px,' + (y - GHOST_SIZE / 2) + 'px,0) rotate(' + rotate + 'deg) scale(' + scale + ')';

    const centerOf = (el) => {
      const r = el.getBoundingClientRect();
      return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
    };

    /* =======================================================
       CAROUSEL (arrows, wheel, disabled states, autoplay)
    ======================================================= */
    function initCarousel(root) {
      const carousel = root.querySelector('[data-flavour-carousel]');
      if (!carousel) return;

      const previousButton = root.querySelector('[data-carousel-previous]');
      const nextButton = root.querySelector('[data-carousel-next]');

      /* FIX: declared up here so the arrow / wheel / keyboard handlers can
         always call it. Previously it was declared inside an if/else block,
         which is block-scoped in strict mode and threw a ReferenceError
         whenever an arrow was clicked. */
      let resetAutoplay = function () {};

      function getScrollAmount() {
        const firstCard = carousel.querySelector('.dojo-build-box__flavour-card');
        if (!firstCard) return carousel.clientWidth;
        const cardWidth = firstCard.getBoundingClientRect().width;
        const style = window.getComputedStyle(carousel);
        const gap = parseFloat(style.columnGap || style.gap) || 0;
        return cardWidth + gap;
      }

      function updateArrowState() {
        const maxScroll = carousel.scrollWidth - carousel.clientWidth;
        const current = carousel.scrollLeft;
        const tolerance = 2;
        if (previousButton) previousButton.disabled = current <= tolerance;
        if (nextButton) nextButton.disabled = current >= maxScroll - tolerance;
      }

      if (previousButton) {
        previousButton.addEventListener('click', () => {
          carousel.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
          resetAutoplay();
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => {
          carousel.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
          resetAutoplay();
        });
      }

      carousel.addEventListener('scroll', updateArrowState, { passive: true });

      /* Mouse wheel moves the carousel sideways while the cursor is over it. */
      carousel.addEventListener(
        'wheel',
        (event) => {
          if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;

          const maxScroll = carousel.scrollWidth - carousel.clientWidth;
          if (maxScroll <= 1) return;

          const direction = event.deltaY;
          const canScroll =
            (direction > 0 && carousel.scrollLeft < maxScroll - 1) ||
            (direction < 0 && carousel.scrollLeft > 1);

          if (!canScroll) return;

          event.preventDefault();
          carousel.scrollLeft += direction;
          resetAutoplay();
        },
        { passive: false }
      );

      /* Keyboard support */
      carousel.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          carousel.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
          resetAutoplay();
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          carousel.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
          resetAutoplay();
        }
      });

      /* Drag the carousel itself on desktop (cards are left to the box drag). */
      let carouselDragging = false;
      let carouselStartX = 0;
      let carouselStartScroll = 0;

      carousel.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        if (event.target.closest('.dojo-build-box__flavour-card, button, a')) return;

        carouselDragging = true;
        carouselStartX = event.clientX;
        carouselStartScroll = carousel.scrollLeft;
        carousel.setPointerCapture(event.pointerId);
        carousel.classList.add('is-pointer-dragging');
      });

      carousel.addEventListener('pointermove', (event) => {
        if (!carouselDragging) return;
        carousel.scrollLeft = carouselStartScroll - (event.clientX - carouselStartX);
      });

      const stopCarouselDrag = (event) => {
        if (!carouselDragging) return;
        carouselDragging = false;
        carousel.classList.remove('is-pointer-dragging');
        if (event.pointerId !== undefined && carousel.hasPointerCapture(event.pointerId)) {
          carousel.releasePointerCapture(event.pointerId);
        }
      };

      carousel.addEventListener('pointerup', stopCarouselDrag);
      carousel.addEventListener('pointercancel', stopCarouselDrag);

      window.addEventListener('resize', updateArrowState);
      carousel.querySelectorAll('img').forEach((img) => img.addEventListener('load', updateArrowState));
      requestAnimationFrame(updateArrowState);

      /* -----------------------------------------------------
         AUTO-SCROLL (every 3s; pauses on hover / touch / focus /
         manual navigation; loops back to the start)
      ----------------------------------------------------- */
      if (!reduceMotion.matches) {
        const AUTOPLAY_DELAY = 3000;
        let autoplayTimer = null;

        const autoplayStep = () => {
          const maxScroll = carousel.scrollWidth - carousel.clientWidth;
          if (maxScroll <= 1) return;
          if (carousel.scrollLeft >= maxScroll - 5) {
            carousel.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            carousel.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
          }
        };

        const stopAutoplay = () => {
          if (autoplayTimer) {
            window.clearInterval(autoplayTimer);
            autoplayTimer = null;
          }
        };

        const startAutoplay = () => {
          stopAutoplay();
          autoplayTimer = window.setInterval(autoplayStep, AUTOPLAY_DELAY);
        };

        resetAutoplay = function () {
          stopAutoplay();
          startAutoplay();
        };

        carousel.addEventListener('mouseenter', stopAutoplay);
        carousel.addEventListener('mouseleave', startAutoplay);
        carousel.addEventListener('pointerdown', stopAutoplay);
        carousel.addEventListener('touchstart', stopAutoplay, { passive: true });
        carousel.addEventListener('touchend', () => {
          window.setTimeout(startAutoplay, 2000);
        });
        carousel.addEventListener('focusin', stopAutoplay);
        carousel.addEventListener('focusout', startAutoplay);

        startAutoplay();
      }
    }

    /* =======================================================
       SCROLL REVEAL
    ======================================================= */
    function initReveal(root) {
      root.classList.add('has-js');
      const nodes = root.querySelectorAll('[data-reveal]');

      if (!('IntersectionObserver' in window) || reduceMotion.matches) {
        nodes.forEach((node) => node.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          let order = 0;
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.style.setProperty('--dojo-reveal-index', order++);
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.15 }
      );

      nodes.forEach((node) => observer.observe(node));
    }

    /* =======================================================
       BOX BUILDER (select, drag & drop, animations)
    ======================================================= */
    function initBuilder(root) {
      const cards = Array.prototype.slice.call(root.querySelectorAll('[data-flavour-card]'));
      if (!cards.length) return;

      const summaryCard = root.querySelector('[data-summary-card]');
      const slotEls = Array.prototype.slice.call(root.querySelectorAll('[data-slot]'));
      const statusEl = root.querySelector('[data-status-message]');
      const countEl = root.querySelector('[data-count]');
      const progressFill = root.querySelector('[data-progress-fill]');
      const clearButton = root.querySelector('[data-clear]');
      const cartButton = root.querySelector('[data-cart-button]');

      const maxItems = parseInt(root.dataset.maxFlavours, 10) || 6;
      const minItems = Math.min(parseInt(root.dataset.minFlavours, 10) || 4, maxItems);
      const allowDuplicates = root.dataset.allowDuplicates === 'true';
      const tiltEnabled = root.dataset.enableTilt === 'true';

      root.classList.toggle('is-duplicates', allowDuplicates);

      const flavours = {};
      cards.forEach((card) => {
        flavours[card.dataset.flavourId] = {
          id: card.dataset.flavourId,
          variant: card.dataset.flavourVariant,
          name: card.dataset.flavourName,
          type: card.dataset.flavourType,
          card: card,
          image: card.querySelector('.dojo-build-box__flavour-image img'),
          imageWrap: card.querySelector('.dojo-build-box__flavour-image'),
          button: card.querySelector('[data-add-button]'),
          label: card.querySelector('[data-add-label]'),
          badge: card.querySelector('[data-card-badge]'),
          badgeCount: card.querySelector('[data-badge-count]'),
        };
      });

      let items = []; // committed flavour ids (in slot order)
      let pending = []; // ids currently "flying" into the box
      let dropOver = false;
      let flashing = false;
      let flashTimer = 0;
      let drag = null;

      const srcOf = (id) => {
        const img = flavours[id] && flavours[id].image;
        return img ? img.currentSrc || img.src : '';
      };

      const getDetail = () => ({
        items: items.map((id) => ({
          id: Number(id),
          variantId: Number(flavours[id].variant) || null,
          name: flavours[id].name,
          type: flavours[id].type,
          image: srcOf(id),
        })),
        count: items.length,
        min: minItems,
        max: maxItems,
        isValid: items.length >= minItems && items.length <= maxItems,
      });

      const shake = (el) => {
        if (!el) return;
        el.classList.remove('is-shake');
        void el.offsetWidth;
        el.classList.add('is-shake');
        el.addEventListener('animationend', () => el.classList.remove('is-shake'), { once: true });
      };

      /* ---------- status text ---------- */
      function renderStatus() {
        if (!statusEl || flashing) return;
        const count = items.length;
        const vars = {
          count: count,
          min: minItems,
          max: maxItems,
          remaining: Math.max(minItems - count, 0),
          spare: Math.max(maxItems - count, 0),
        };
        let text;
        if (dropOver && root.dataset.msgDrop) text = root.dataset.msgDrop;
        else if (count === 0) text = root.dataset.msgEmpty;
        else if (count < minItems) text = fill(root.dataset.msgNeedMore, vars);
        else if (count < maxItems) text = fill(root.dataset.msgReady, vars);
        else text = fill(root.dataset.msgFull, vars);

        statusEl.textContent = text;
        statusEl.classList.remove('is-warning');
        statusEl.classList.toggle('is-drop', dropOver);
      }

      function flash(text) {
        if (!statusEl || !text) return;
        flashing = true;
        statusEl.textContent = text;
        statusEl.classList.remove('is-warning');
        void statusEl.offsetWidth;
        statusEl.classList.add('is-warning');
        window.clearTimeout(flashTimer);
        flashTimer = window.setTimeout(() => {
          flashing = false;
          renderStatus();
        }, 2200);
      }

      /* ---------- main render ---------- */
      function render(justAddedIndex) {
        const count = items.length;
        const full = count + pending.length >= maxItems;
        const valid = count >= minItems && count <= maxItems;

        slotEls.forEach((slot, index) => {
          const id = items[index];
          const data = id ? flavours[id] : null;
          const image = slot.querySelector('[data-slot-image]');
          const label = slot.querySelector('[data-slot-label]');
          const remove = slot.querySelector('[data-slot-remove]');

          slot.classList.toggle('is-filled', !!data);
          slot.classList.toggle('is-next', index === count);

          if (data) {
            image.src = srcOf(id);
            image.alt = data.name;
            image.hidden = false;
            label.textContent = data.name;
            remove.hidden = false;
            remove.setAttribute('aria-label', root.dataset.removeLabel + ' ' + data.name);
            if (index === justAddedIndex) {
              slot.classList.remove('is-pop');
              void slot.offsetWidth;
              slot.classList.add('is-pop');
            }
          } else {
            image.hidden = true;
            image.removeAttribute('src');
            image.alt = '';
            label.textContent = slot.dataset.defaultLabel;
            remove.hidden = true;
            slot.classList.remove('is-pop');
          }
        });

        Object.keys(flavours).forEach((id) => {
          const f = flavours[id];
          const n = items.filter((x) => x === id).length;
          const selected = n > 0;

          f.card.classList.toggle('is-selected', selected);
          f.card.classList.toggle('is-unavailable', full && (allowDuplicates || !selected));

          if (f.button) {
            const pressed = selected && !allowDuplicates;
            f.button.setAttribute('aria-pressed', pressed ? 'true' : 'false');
            if (f.label) f.label.textContent = pressed ? root.dataset.addedText : f.button.dataset.labelAdd;
          }

          if (f.badge) {
            f.badge.hidden = !selected;
            if (f.badgeCount) f.badgeCount.textContent = n;
          }
        });

        if (progressFill) progressFill.style.width = (count / maxItems) * 100 + '%';

        if (countEl) {
          const text = count + ' / ' + maxItems;
          if (countEl.textContent !== text) {
            countEl.textContent = text;
            countEl.classList.remove('is-bump');
            void countEl.offsetWidth;
            countEl.classList.add('is-bump');
          }
        }

        if (clearButton) clearButton.hidden = count === 0;

        if (cartButton) {
          cartButton.disabled = !valid;
          root.classList.toggle('is-ready', valid);
        }

        renderStatus();

        root.dispatchEvent(
          new CustomEvent('dojo-build-box:change', { bubbles: true, detail: getDetail() })
        );
      }

      /* ---------- ghost helpers ---------- */
      function createGhost(src, x, y) {
        const ghost = document.createElement('div');
        ghost.className = 'dojo-build-box__ghost';
        ghost.setAttribute('aria-hidden', 'true');
        const img = document.createElement('img');
        img.src = src;
        img.alt = '';
        img.draggable = false;
        ghost.appendChild(img);
        root.appendChild(ghost);
        ghost.style.transform = tf(x, y, 0, 1.05);
        return ghost;
      }

      function flyGhost(ghost, from, to, toSize, fade, done, duration, arc) {
        if (reduceMotion.matches || typeof ghost.animate !== 'function') {
          ghost.remove();
          done();
          return;
        }

        const scale = toSize / GHOST_SIZE;
        const mid = {
          x: (from.x + to.x) / 2,
          y: arc ? Math.min(from.y, to.y) - 60 : (from.y + to.y) / 2,
        };

        const animation = ghost.animate(
          [
            { transform: tf(from.x, from.y, from.rot || 0, 1.05), opacity: 1, offset: 0 },
            { transform: tf(mid.x, mid.y, 0, 1.12), opacity: 1, offset: 0.5 },
            { transform: tf(to.x, to.y, 0, scale), opacity: fade ? 0 : 1, offset: 1 },
          ],
          { duration: duration || 560, easing: 'cubic-bezier(0.45, 0.05, 0.25, 1)', fill: 'forwards' }
        );

        const finish = () => {
          ghost.remove();
          done();
        };
        animation.onfinish = finish;
        animation.oncancel = finish;
      }

      function returnGhost(d) {
        const finish = () => d.card.classList.remove('is-dragging');
        if (!d.ghost) {
          finish();
          return;
        }
        const target = centerOf(d.card.querySelector('.dojo-build-box__flavour-image'));
        flyGhost(d.ghost, { x: d.x, y: d.y, rot: d.rot }, target, GHOST_SIZE, false, finish, 380, false);
      }

      /* ---------- add / remove ---------- */
      function canAdd(id) {
        if (items.length + pending.length >= maxItems) return 'full';
        if (!allowDuplicates && (items.indexOf(id) !== -1 || pending.indexOf(id) !== -1)) return 'duplicate';
        return true;
      }

      function addFlavour(id, origin) {
        const reason = canAdd(id);

        if (reason !== true) {
          flash(reason === 'duplicate' ? root.dataset.msgDuplicate : root.dataset.msgFull);
          shake(summaryCard);
          shake(flavours[id].card);
          if (origin && origin.ghost) returnGhost(origin);
          return;
        }

        const targetIndex = items.length + pending.length;
        pending.push(id);

        const commit = () => {
          const p = pending.indexOf(id);
          if (p !== -1) pending.splice(p, 1);
          items.push(id);
          render(items.length - 1);
        };

        const slot = slotEls[targetIndex];
        const circle = slot && slot.querySelector('.dojo-build-box__selected-circle');

        if (!circle || reduceMotion.matches) {
          if (origin && origin.ghost) origin.ghost.remove();
          commit();
          return;
        }

        const from = origin && origin.ghost
          ? { x: origin.x, y: origin.y, rot: origin.rot }
          : centerOf(flavours[id].imageWrap);

        const ghost = origin && origin.ghost ? origin.ghost : createGhost(srcOf(id), from.x, from.y);

        const rect = circle.getBoundingClientRect();
        const to = { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 };
        const offscreen = to.y < 0 || to.y > window.innerHeight;
        if (offscreen) to.y = clamp(to.y, 24, window.innerHeight - 24);

        flyGhost(ghost, from, to, rect.width, offscreen, commit, 560, true);
      }

      function removeAt(index) {
        if (index < 0 || index >= items.length) return;
        items.splice(index, 1);
        render();
      }

      /* ---------- tilt ---------- */
      function resetTilt(card) {
        const visual = card.querySelector('[data-tilt-target]');
        if (!visual) return;
        visual.style.removeProperty('--rx');
        visual.style.removeProperty('--ry');
        visual.style.removeProperty('--glow-x');
        visual.style.removeProperty('--glow-y');
      }

      if (tiltEnabled && finePointer.matches) {
        cards.forEach((card) => {
          const stage = card.querySelector('[data-tilt-stage]');
          const visual = card.querySelector('[data-tilt-target]');
          if (!stage || !visual) return;

          card.addEventListener('pointermove', (event) => {
            if (event.pointerType !== 'mouse' || drag) return;
            const r = stage.getBoundingClientRect();
            const px = clamp((event.clientX - r.left) / r.width, 0, 1);
            const py = clamp((event.clientY - r.top) / r.height, 0, 1);
            visual.style.setProperty('--rx', ((0.5 - py) * 9).toFixed(2) + 'deg');
            visual.style.setProperty('--ry', ((px - 0.5) * 11).toFixed(2) + 'deg');
            visual.style.setProperty('--glow-x', (px * 100).toFixed(1) + '%');
            visual.style.setProperty('--glow-y', (py * 100).toFixed(1) + '%');
          });

          card.addEventListener('pointerleave', () => resetTilt(card));
        });
      }

      /* ---------- drag & drop ---------- */
      function isOverSummary(x, y) {
        if (!summaryCard) return false;
        const r = summaryCard.getBoundingClientRect();
        const pad = 24;
        return x >= r.left - pad && x <= r.right + pad && y >= r.top - pad && y <= r.bottom + pad;
      }

      function blockTouchMove(event) {
        if (drag && drag.active && event.cancelable) event.preventDefault();
      }

      function teardown(d) {
        window.clearTimeout(d.timer);
        window.cancelAnimationFrame(d.raf);
        document.removeEventListener('pointermove', onPointerMove);
        document.removeEventListener('pointerup', onPointerUp);
        document.removeEventListener('pointercancel', onPointerCancel);
        document.removeEventListener('keydown', onKeyDown);
        document.removeEventListener('touchmove', blockTouchMove);
        window.removeEventListener('blur', onBlur);
      }

      function abortPending() {
        if (!drag) return;
        const d = drag;
        d.card.classList.remove('is-pressing');
        teardown(d);
        drag = null;
      }

      function onPointerDown(event) {
        if (drag) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (event.target.closest('button, a, input')) return;

        const card = event.currentTarget;

        drag = {
          card: card,
          id: card.dataset.flavourId,
          pointerId: event.pointerId,
          isTouch: event.pointerType === 'touch',
          startX: event.clientX,
          startY: event.clientY,
          x: event.clientX,
          y: event.clientY,
          lastX: event.clientX,
          rot: 0,
          active: false,
          over: false,
          ghost: null,
          raf: 0,
          timer: 0,
        };

        document.addEventListener('pointermove', onPointerMove);
        document.addEventListener('pointerup', onPointerUp);
        document.addEventListener('pointercancel', onPointerCancel);
        document.addEventListener('keydown', onKeyDown);
        window.addEventListener('blur', onBlur);

        // Touch: long-press to pick up, so normal swiping still scrolls the carousel
        if (drag.isTouch) {
          card.classList.add('is-pressing');
          drag.timer = window.setTimeout(startDrag, 220);
        }
      }

      function onPointerMove(event) {
        if (!drag || event.pointerId !== drag.pointerId) return;
        drag.x = event.clientX;
        drag.y = event.clientY;

        if (!drag.active) {
          const moved = Math.hypot(drag.x - drag.startX, drag.y - drag.startY);
          if (drag.isTouch) {
            if (moved > 10) abortPending(); // user is swiping, not dragging
          } else if (moved > 6) {
            startDrag();
          }
          return;
        }

        if (event.cancelable) event.preventDefault();
      }

      function startDrag() {
        if (!drag || drag.active) return;
        const d = drag;
        d.active = true;
        window.clearTimeout(d.timer);

        d.card.classList.remove('is-pressing');
        d.card.classList.add('is-dragging');
        resetTilt(d.card);

        root.classList.add('is-dragging');
        if (summaryCard) summaryCard.classList.add('is-drop-ready');

        d.ghost = createGhost(srcOf(d.id), d.x, d.y);

        if (d.isTouch) {
          document.addEventListener('touchmove', blockTouchMove, { passive: false });
          if (navigator.vibrate) navigator.vibrate(12);
        }

        const selection = window.getSelection && window.getSelection();
        if (selection) selection.removeAllRanges();

        d.lastX = d.x;
        d.raf = window.requestAnimationFrame(dragLoop);
      }

      function dragLoop() {
        if (!drag || !drag.active) return;
        const d = drag;

        // auto-scroll the page when dragging near the top / bottom edge
        const edge = 90;
        let speed = 0;
        if (d.y < edge) speed = -((edge - d.y) / edge) * 18;
        else if (d.y > window.innerHeight - edge) speed = ((d.y - (window.innerHeight - edge)) / edge) * 18;
        if (speed) window.scrollBy(0, speed);

        // ghost tilts with horizontal speed
        const targetRot = clamp((d.x - d.lastX) * 1.4, -16, 16);
        d.rot += (targetRot - d.rot) * 0.25;
        d.lastX = d.x;
        d.ghost.style.transform = tf(d.x, d.y, d.rot, 1.08);

        const over = isOverSummary(d.x, d.y);
        if (over !== d.over) {
          d.over = over;
          dropOver = over;
          if (summaryCard) summaryCard.classList.toggle('is-drop-over', over);
          d.ghost.classList.toggle('is-over', over);
          renderStatus();
        }

        d.raf = window.requestAnimationFrame(dragLoop);
      }

      function finishDrag(cancelled) {
        if (!drag) return;
        const d = drag;
        const wasActive = d.active;

        d.card.classList.remove('is-pressing');
        teardown(d);
        drag = null;

        if (!wasActive) return; // it was just a click

        root.classList.remove('is-dragging');
        if (summaryCard) summaryCard.classList.remove('is-drop-ready', 'is-drop-over');
        dropOver = false;
        renderStatus();

        const dropped = !cancelled && isOverSummary(d.x, d.y);

        if (dropped) {
          d.card.classList.remove('is-dragging');
          addFlavour(d.id, { ghost: d.ghost, x: d.x, y: d.y, rot: d.rot, card: d.card });
        } else {
          returnGhost(d);
        }
      }

      function onPointerUp(event) {
        if (!drag || event.pointerId !== drag.pointerId) return;
        finishDrag(false);
      }

      function onPointerCancel(event) {
        if (!drag || event.pointerId !== drag.pointerId) return;
        finishDrag(true);
      }

      function onKeyDown(event) {
        if (event.key === 'Escape') finishDrag(true);
      }

      function onBlur() {
        finishDrag(true);
      }

      /* ---------- wire up ---------- */
      root.addEventListener('dragstart', (event) => event.preventDefault());

      cards.forEach((card) => {
        const f = flavours[card.dataset.flavourId];

        card.addEventListener('pointerdown', onPointerDown);

        card.addEventListener('contextmenu', (event) => {
          if (!finePointer.matches) event.preventDefault();
        });

        if (f.button) {
          f.button.addEventListener('click', () => {
            const id = f.id;
            if (!allowDuplicates && items.indexOf(id) !== -1) {
              removeAt(items.indexOf(id)); // button acts as a toggle
              return;
            }
            addFlavour(id, { card: card });
          });
        }
      });

      slotEls.forEach((slot, index) => {
        const remove = slot.querySelector('[data-slot-remove]');
        if (remove) remove.addEventListener('click', () => removeAt(index));
      });

      if (clearButton) {
        clearButton.addEventListener('click', () => {
          items = [];
          render();
        });
      }

      if (cartButton) {
        cartButton.addEventListener('click', () => {
          if (cartButton.disabled) return;
          root.dispatchEvent(
            new CustomEvent('dojo-build-box:submit', { bubbles: true, detail: getDetail() })
          );
        });
      }

      render();
    }

    /* =======================================================
       INIT
    ======================================================= */
    function initializeDojoBuildBox(root) {
      if (!root || root.dataset.dojoInitialized === 'true') return;
      root.dataset.dojoInitialized = 'true';
      initCarousel(root);
      initBuilder(root);
      initReveal(root);
    }

    function initializeAllDojoBuildBoxes() {
      document.querySelectorAll('[data-dojo-build-box]').forEach(initializeDojoBuildBox);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAllDojoBuildBoxes);
    } else {
      initializeAllDojoBuildBoxes();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector ? event.target.querySelector('[data-dojo-build-box]') : null;
      if (section) initializeDojoBuildBox(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
